// src/reducers/AdminBookingRequestReducer.js

import {
    FETCH_BOOKING_REQUESTS_REQUEST,
    FETCH_BOOKING_REQUESTS_SUCCESS,
    FETCH_BOOKING_REQUESTS_FAIL,
    ADMIN_FIND_NEAREST_DRIVER_REQUEST,
    ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
    ADMIN_FIND_NEAREST_DRIVER_FAIL,
    ADMIN_ACCEPT_BOOKING_REQUEST,
    ADMIN_ACCEPT_BOOKING_SUCCESS,
    ADMIN_ACCEPT_BOOKING_FAIL,
    ADMIN_CHECK_CONFLICT_REQUEST,
    ADMIN_CHECK_CONFLICT_SUCCESS,
    ADMIN_CHECK_CONFLICT_FAIL,
    RESET_ADMIN_BOOKING_REQUEST,
    ADMIN_CANCEL_BOOKING_REQUEST,
    ADMIN_CANCEL_BOOKING_SUCCESS,
    ADMIN_CANCEL_BOOKING_FAIL,
} from '../constants/AdminBookingRequestConstants'

const fetchInit   = { bookingRequests: [], loading: false, error: null }
const nearestInit = { nearest: null, ranked: [], loading: false, error: null }
const acceptInit  = { loading: false, error: null, success: false }
// conflicted: null = not checked yet, true = vehicle busy, false = vehicle free
const conflictInit = { loading: false, conflicted: null, error: null }
const cancelInit = { loading: false, error: null, success: false }
const acceptedReqIdsInit = { reqIds: [] }

export const fetchBookingRequestsReducer = (state = fetchInit, action) => {
    switch (action.type) {
        case FETCH_BOOKING_REQUESTS_REQUEST: return { ...state, loading: true,  error: null }
        case FETCH_BOOKING_REQUESTS_SUCCESS: return { ...state, loading: false, bookingRequests: action.payload, error: null }
        case FETCH_BOOKING_REQUESTS_FAIL:    return { ...state, loading: false, error: action.payload }
        // intentionally no RESET case — closing the accept modal must never wipe the booking list
        default: return state
    }
}

export const acceptedReqIdsReducer = (state = acceptedReqIdsInit, action) => {
    switch (action.type) {
        case SET_ACCEPTED_REQIDS: return { ...state, reqIds: action.payload }
        default: return state
    }
}

export const adminFindNearestDriverReducer = (state = nearestInit, action) => {
    switch (action.type) {
        case ADMIN_FIND_NEAREST_DRIVER_REQUEST: return { ...state, loading: true,  error: null, nearest: null, ranked: [] }
        case ADMIN_FIND_NEAREST_DRIVER_SUCCESS: return { ...state, loading: false, nearest: action.payload.nearest, ranked: action.payload.ranked, error: null }
        case ADMIN_FIND_NEAREST_DRIVER_FAIL:    return { ...state, loading: false, error: action.payload }
        case RESET_ADMIN_BOOKING_REQUEST:       return nearestInit
        default: return state
    }
}

export const adminAcceptBookingReducer = (state = acceptInit, action) => {
    switch (action.type) {
        case ADMIN_ACCEPT_BOOKING_REQUEST: return { ...state, loading: true,  error: null, success: false }
        case ADMIN_ACCEPT_BOOKING_SUCCESS: return { ...state, loading: false, success: true, error: null }
        case ADMIN_ACCEPT_BOOKING_FAIL:    return { ...state, loading: false, error: action.payload, success: false }
        case RESET_ADMIN_BOOKING_REQUEST:  return acceptInit
        default: return state
    }
}

export const adminCancelBookingReducer = (state = cancelInit, action) => {
    switch (action.type) {
        case ADMIN_CANCEL_BOOKING_REQUEST: return { ...state, loading: true, error: null, success: false }
        case ADMIN_CANCEL_BOOKING_SUCCESS: return { ...state, loading: false, success: true, error: null }
        case ADMIN_CANCEL_BOOKING_FAIL: return { ...state, loading: false, error: action.payload, success: false }
        case RESET_ADMIN_BOOKING_REQUEST: return cancelInit
        default: return state
    }
}

export const adminCheckConflictReducer = (state = conflictInit, action) => {
    switch (action.type) {
        case ADMIN_CHECK_CONFLICT_REQUEST: return { ...state, loading: true,  conflicted: null, error: null }
        case ADMIN_CHECK_CONFLICT_SUCCESS: return { ...state, loading: false, conflicted: action.payload, error: null }
        case ADMIN_CHECK_CONFLICT_FAIL:    return { ...state, loading: false, error: action.payload, conflicted: null }
        case RESET_ADMIN_BOOKING_REQUEST:  return conflictInit
        default: return state
    }
}